<section class="breadcrumbs_common bg_img pos_relative">
  <div class="overlay-innerpage"></div>
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-12">
        <div class="breadcrumbs_content">
          <h2 class="text-white">AQAR 2021 - 2022</h2>
          <ul class="breadcrumb">
            <li>
              <a routerLink="/">Home</a>
            </li>/
            <li class="active">
              <a routerLink="/aqar">AQAR 2021 - 2022</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- <section class="calender ptb--100  horizontal--tab">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-4">
        <div class="pdfBox">
          <div class="pdf-icon">
            <span><i class="fa fa-file-pdf-o"></i></span>
          </div>
          <div class="pdf-content">
            <h4>AQAR 2021-22</h4>
            <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/pdf/aqar-21-22.pdf" target="_blank"
              class="cmn-button" target="_blank">Click Here</a>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="pdfBox">
          <div class="pdf-icon">
            <span><i class="fa fa-file-pdf-o"></i></span>
          </div>
          <div class="pdf-content">
            <h4>4.1.3</h4>
            <a href="https://drive.google.com/file/d/1C7FydrKiZeSoCYS73xyBCDMVLyT2kJjw/view?usp=sharing"
              class="cmn-button" target="_blank">Click Here</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</section> -->
<section class="online-anti-ragging ptb--100  verticaltab--1">
  <div class="container">
    <div class="row">
      <div class="col">
        <div class="row align-items-start hustify-content-center">
          <div class="nav flex-column nav-pills col-3" id="v-pills-tab" role="tablist" aria-orientation="vertical">
            <button class="nav-link active" id="v-pills-criteria1-tab" data-bs-toggle="pill"
              data-bs-target="#v-pills-criteria1" type="button" role="tab" aria-controls="v-pills-criteria1"
              aria-selected="true">Criteria-1</button>
            <button class="nav-link" id="v-pills-Criteria2-tab" data-bs-toggle="pill"
              data-bs-target="#v-pills-Criteria2" type="button" role="tab" aria-controls="v-pills-Criteria2"
              aria-selected="false">Criteria-2</button>
            <button class="nav-link" id="v-pills-Criteria3-tab" data-bs-toggle="pill"
              data-bs-target="#v-pills-Criteria3" type="button" role="tab" aria-controls="v-pills-Criteria3"
              aria-selected="false">Criteria-3</button>
            <button class="nav-link" id="v-pills-Criteria4-tab" data-bs-toggle="pill"
              data-bs-target="#v-pills-Criteria4" type="button" role="tab" aria-controls="v-pills-Criteria4"
              aria-selected="false">Criteria-4</button>
            <button class="nav-link" id="v-pills-Criteria5-tab" data-bs-toggle="pill"
              data-bs-target="#v-pills-Criteria5" type="button" role="tab" aria-controls="v-pills-Criteria5"
              aria-selected="false">Criteria-5</button>
            <button class="nav-link" id="v-pills-Criteria6-tab" data-bs-toggle="pill"
              data-bs-target="#v-pills-Criteria6" type="button" role="tab" aria-controls="v-pills-Criteria6"
              aria-selected="false">Criteria-6</button>
            <button class="nav-link" id="v-pills-Criteria7-tab" data-bs-toggle="pill"
              data-bs-target="#v-pills-Criteria7" type="button" role="tab" aria-controls="v-pills-Criteria7"
              aria-selected="false">Criteria-7</button>
            <button class="nav-link" id="v-pills-template-tab" data-bs-toggle="pill" data-bs-target="#v-pills-template"
              type="button" role="tab" aria-controls="v-pills-template" aria-selected="false">Extended Template</button>
          </div>
          <div class="tab-content col-9" id="v-pills-tabContent">
            <!-- criteria 1 -->
            <div class="tab-pane fade show active" id="v-pills-criteria1" role="tabpanel"
              aria-labelledby="v-pills-criteria1-tab">
              <h3 class="yellow-color">Criteria 1</h3>
              <div class="row row-cols-1 justify-content-start align-items-top mt-3">
                <div class="accordion accordian-class table--1" id="criteria1">
                  <div class="accordion-item">
                    <h2 class="accordion-header accordion-button" id="criteria1-1" data-bs-toggle="collapse"
                      data-bs-target="#criteria1-1-1" aria-expanded="true" aria-controls="criteria1-2-1">
                      1.1
                    </h2>
                    <div id="criteria1-1-1" class="accordion-collapse collapse show" aria-labelledby="criteria1-1"
                      data-bs-parent="#criteria1">
                      <div class="accordion-body">
                        <ul class="list-before">
                          <!-- <li><a href="https://drive.google.com/file/d/1tKeWO2X3k_36m0zCV5g9jxfj44lty1Mh/view" target="_blank">1.1.1</a></li>
                                        <li><a href="https://drive.google.com/file/d/1NhpVQrW9kGwF7t5gXjTPy1MOcECJltx8/view" target="_blank">1.1.2</a></li> -->
                          <li><a href="https://drive.google.com/file/d/1vTTOdRtgkDTBelfnmJlH5kCJeTnigm74/view"
                              target="_blank">1.1.1</a></li>
                          <li><a href="https://drive.google.com/file/d/1CmwDDdENsvn5hzvT6PNl4teRsIA37AMH/view"
                              target="_blank">1.1.2</a></li>
                          <li><a href="https://drive.google.com/file/d/1lY2pPd6k0dIRaDGwvO8_oNQWVZNOc_Hu/view"
                              target="_blank">1.1.3</a></li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header accordion-button" id="criteria1-3" data-bs-toggle="collapse"
                      data-bs-target="#criteria1-3-2" aria-expanded="true" aria-controls="collapseOne">
                      1.3
                    </h2>
                    <div id="criteria1-3-2" class="accordion-collapse collapse" aria-labelledby="criteria1-3"
                      data-bs-parent="#criteria1">
                      <div class="accordion-body">
                        <ul class="list-before">
                          <li><a href="https://drive.google.com/file/d/1lRsi2veYleojBiIZfeSBEI6GD6OkpP4X/view"
                              target="_blank">1.3.1</a></li>
                          <li><a href="assets/pdf/1.3.2 FINAL.pdf" target="_blank">1.3.2</a></li>
                          <li><a href="https://drive.google.com/file/d/1KmM1qr8fps91oycpbt_FQiyu2TyZ6L_d/view"
                              target="_blank">1.3.3</a></li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="accordion accordian-class table--1" id="criteria_1">
                  <div class="accordion-item">
                    <h2 class="accordion-header accordion-button" id="criteria1-2" data-bs-toggle="collapse"
                      data-bs-target="#criteria1-2-1" aria-expanded="true" aria-controls="criteria1-2-1">
                      1.2
                    </h2>
                    <div id="criteria1-2-1" class="accordion-collapse collapse" aria-labelledby="criteria1-2"
                      data-bs-parent="#criteria_1">
                      <div class="accordion-body">
                        <ul class="list-before">
                          <li><a href="https://drive.google.com/file/d/1TKeBvmG18aZ7RbIURqtfDHuGw-mSk3WX/view"
                              target="_blank">1.2.1</a></li>
                          <li><a href="https://drive.google.com/file/d/1fDCm5S7tXK7Gr2MKhmbZk2y0TTy8tSs6/view"
                              target="_blank">1.2.2</a></li>
                          <li><a href="https://drive.google.com/file/d/1aMym3pxiGoc1xt132Nyeg2yPdZN1nXy6/view"
                              target="_blank">1.2.3</a></li>
                        </ul>
                      </div>
                    </div>
                  </div>

                  <div class="accordion-item">
                    <h2 class="accordion-header accordion-button" id="criteria1-4" data-bs-toggle="collapse"
                      data-bs-target="#criteria1-4-2" aria-expanded="true" aria-controls="collapseOne">
                      1.4
                    </h2>
                    <div id="criteria1-4-2" class="accordion-collapse collapse" aria-labelledby="criteria1-4"
                      data-bs-parent="#criteria_1">
                      <div class="accordion-body">
                        <ul class="list-before">
                          <li><a href="https://drive.google.com/file/d/1IE-hMiMp4inSOu-HFv3nccAGTWUX60-F/view"
                              target="_blank">1.4.1</a></li>
                          <li><a href="https://drive.google.com/file/d/1TvoufhDYrEArzug6unfm9uRxEfFtJO2y/view"
                              target="_blank">1.4.2</a></li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- criteria 2 -->
            <div class="tab-pane fade" id="v-pills-Criteria2" role="tabpanel" aria-labelledby="v-pills-Criteria2-tab">
              <h3 class="yellow-color">Criteria 2</h3>
              <div class="row row-cols-1 justify-content-start align-items-top mt-3">
                <div class="accordion accordian-class table--1" id="criteria2">
                  <div class="accordion-item">
                    <h2 class="accordion-header accordion-button" id="criteria2-1" data-bs-toggle="collapse"
                      data-bs-target="#criteria2-1-2" aria-expanded="true" aria-controls="collapseOne">
                      2.1
                    </h2>
                    <div id="criteria2-1-2" class="accordion-collapse collapse show" aria-labelledby="criteria2-1"
                      data-bs-parent="#criteria2">
                      <div class="accordion-body">
                        <ul class="list-before">
                          <li><a href="https://drive.google.com/file/d/1gP9A58j557NdaJsAVVjz0jSC9t4T8Dia/view"
                              target="_blank">2.1.1</a></li>
                          <li><a href="https://drive.google.com/file/d/1_qAJB3QJ1J9yj8aUzA7q73pPXASdFLeP/view"
                              target="_blank">2.1.2</a></li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header accordion-button" id="criteria2-3" data-bs-toggle="collapse"
                      data-bs-target="#criteria2-3-1" aria-expanded="true" aria-controls="collapseOne">
                      2.3
                    </h2>
                    <div id="criteria2-3-1" class="accordion-collapse collapse" aria-labelledby="criteria2-3"
                      data-bs-parent="#criteria2">
                      <div class="accordion-body">
                        <ul class="list-before">
                          <li><a href="https://drive.google.com/file/d/1chenH5H3bBiQBcjSwrFIcIfZuQazb16f/view"
                              target="_blank">2.3.1</a></li>
                          <li><a href="https://drive.google.com/file/d/1VYyIbXvzemBIfWkQrlEftFKMZ222HLY2/view"
                              target="_blank">2.3.2</a></li>
                          <li><a href="https://drive.google.com/file/d/1Q3Abu1jxDcrXZz8ukWLPeedM71WgZhdN/view"
                              target="_blank">2.3.3</a></li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header accordion-button" id="criteria2-5" data-bs-toggle="collapse"
                      data-bs-target="#criteria2-5-2" aria-expanded="true" aria-controls="collapseOne">
                      2.5
                    </h2>
                    <div id="criteria2-5-2" class="accordion-collapse collapse" aria-labelledby="criteria2-5"
                      data-bs-parent="#criteria2">
                      <div class="accordion-body">
                        <ul class="list-before">
                          <li><a href="https://drive.google.com/file/d/1kUHV_2xqBES99SqIJUEk9s6sWOOb19OD/view"
                              target="_blank">2.5.1</a></li>
                          <li><a href="https://drive.google.com/file/d/1ylPfdeRcEFp4lHKMWRQpC5UYfzl-zfw5/view"
                              target="_blank">2.5.2</a></li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header accordion-button" id="criteria2-7" data-bs-toggle="collapse"
                      data-bs-target="#criteria2-7-1" aria-expanded="true" aria-controls="collapseOne">
                      2.7
                    </h2>
                    <div id="criteria2-7-1" class="accordion-collapse collapse" aria-labelledby="criteria2-7"
                      data-bs-parent="#criteria_2">
                      <div class="accordion-body">
                        <ul class="list-before main-list">
                          <li><a href="https://drive.google.com/file/d/1--iarsAa0qftsz7Mdny_BiYIAqvFjOFV/view"
                              target="_blank">2.7.1</a></li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="accordion accordian-class table--1" id="criteria_2">
                  <div class="accordion-item">
                    <h2 class="accordion-header accordion-button" id="criteria2-2" data-bs-toggle="collapse"
                      data-bs-target="#criteria2-2-2" aria-expanded="true" aria-controls="collapseOne">
                      2.2
                    </h2>
                    <div id="criteria2-2-2" class="accordion-collapse collapse show" aria-labelledby="criteria2-2"
                      data-bs-parent="#criteria2">
                      <div class="accordion-body">
                        <ul class="list-before">
                          <li><a href="https://drive.google.com/file/d/1AHgS2B6ENdIknNV6_6BSD9maKPKvDMp1/view"
                              target="_blank">2.2.1</a></li>
                          <li><a href="https://drive.google.com/file/d/17GlQPgaIWE-w9Eu_BifGgWBAf0lQt3KG/view"
                              target="_blank">2.2.2</a></li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header accordion-button" id="criteria2-4" data-bs-toggle="collapse"
                      data-bs-target="#criteria2-4-1" aria-expanded="true" aria-controls="collapseOne">
                      2.4
                    </h2>
                    <div id="criteria2-4-1" class="accordion-collapse collapse" aria-labelledby="criteria2-4"
                      data-bs-parent="#criteria2">
                      <div class="accordion-body">
                        <ul class="list-before">
                          <li><a href="https://drive.google.com/file/d/1cULdYokoE5y-HzVWFmD7a4XTHnhvszav/view"
                              target="_blank">2.4.1</a></li>
                          <li><a href="https://drive.google.com/file/d/1sPXIpqbhcM2Pq5wZqzWLlNwdjeSNgmku/view"
                              target="_blank">2.4.2</a></li>
                          <li><a href="https://drive.google.com/file/d/1uE7JtrIOUQ0ByHOFgjJg5Cn0k7mxjqax/view"
                              target="_blank">2.4.3</a></li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header accordion-button" id="criteria2-6" data-bs-toggle="collapse"
                      data-bs-target="#criteria2-6-2" aria-expanded="true" aria-controls="collapseOne">
                      2.6
                    </h2>
                    <div id="criteria2-6-2" class="accordion-collapse collapse" aria-labelledby="criteria2-6"
                      data-bs-parent="#criteria_2">
                      <div class="accordion-body">
                        <ul class="list-before">
                          <li><a href="https://drive.google.com/file/d/1i3vDnXwEas4K0rXyyLB_JNIXhjxX-Hej/view">2.6.1</a>
                          </li>
                          <li><a href="https://drive.google.com/file/d/1DYd1y2yn5Kbl7EkwP9ejndt4xvUqIVSV/view">2.6.2</a>
                          </li>
                          <li><a href="https://drive.google.com/file/d/15bcpJBgAzhIha-jORC6Z1rDE0EoEdgtD/view">2.6.3</a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- criteria 3 -->
            <div class="tab-pane fade" id="v-pills-Criteria3" role="tabpanel" aria-labelledby="v-pills-Criteria3-tab">
              <h3 class="yellow-color">Criteria 3</h3>
              <div class="row row-cols-1 justify-content-start align-items-top mt-3">
                <div class="accordion accordian-class table--1" id="criteria3">
                  <div class="accordion-item">
                    <h2 class="accordion-header accordion-button" id="criteria3-1" data-bs-toggle="collapse"
                      data-bs-target="#criteria3-1-1" aria-expanded="true" aria-controls="collapseOne">
                      3.1
                    </h2>
                    <div id="criteria3-1-1" class="accordion-collapse collapse show" aria-labelledby="criteria3-1"
                      data-bs-parent="#criteria3">
                      <div class="accordion-body">
                        <ul class="list-before">
                          <li><a href="https://drive.google.com/file/d/1aY3sfqTW1JMg2YsmrcQjzdS4taw-rt3L/view">3.1.1</a>
                          </li>
                          <li><a href="https://drive.google.com/file/d/111Fd7lD8ZSBOz6G1tVYzVbDwdJ_R2esS/view">3.1.3</a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header accordion-button" id="criteria3-3" data-bs-toggle="collapse"
                      data-bs-target="#criteria3-3-1" aria-expanded="true" aria-controls="collapseOne">
                      3.3
                    </h2>
                    <div id="criteria3-3-1" class="accordion-collapse collapse" aria-labelledby="criteria3-3"
                      data-bs-parent="#criteria3">
                      <div class="accordion-body">
                        <ul class="list-before">
                          <li><a href="https://drive.google.com/file/d/1NYT7fq6vMFCssy6aBZlW1elNbd3hD-5c/view"
                              target="_blank">3.3.1</a></li>
                          <li><a href="https://drive.google.com/file/d/1Li4ROBtcRaWc9BAOFMlBKfcXllnr8OsM/view"
                              target="_blank">3.3.2</a></li>
                          <li><a href="https://drive.google.com/file/d/128qykiH0tMNaLh5sDu1YzGhTGg7Rr9Yl/view"
                              target="_blank">3.3.3</a></li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="accordion accordian-class table--1" id="criteria_3">
                  <div class="accordion-item">
                    <h2 class="accordion-header accordion-button" id="criteria3-2" data-bs-toggle="collapse"
                      data-bs-target="#criteria3-2-1" aria-expanded="true" aria-controls="collapseOne">
                      3.2
                    </h2>
                    <div id="criteria3-2-1" class="accordion-collapse collapse show" aria-labelledby="criteria3-2"
                      data-bs-parent="#criteria_3">
                      <div class="accordion-body">
                        <ul class="list-before">
                          <li><a href="https://drive.google.com/file/d/1t7IhlVBCCTj3ZPlIfgMHzt0DWjuSce3t/view"
                              target="_blank">3.2.1</a></li>
                          <li><a href="https://drive.google.com/file/d/1P5utb3pL9OiLb9RDzHpEgRNKiy1baVCv/view"
                              target="_blank">3.2.2</a></li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header accordion-button" id="criteria3-4" data-bs-toggle="collapse"
                      data-bs-target="#criteria3-4-1" aria-expanded="true" aria-controls="collapseOne">
                      3.4
                    </h2>
                    <div id="criteria3-4-1" class="accordion-collapse" aria-labelledby="criteria3-4"
                      data-bs-parent="#criteria_3">
                      <div class="accordion-body">
                        <ul class="list-before">
                          <li><a href="https://drive.google.com/file/d/1Fhi-vyfX_lEiL0R6vze6PxsK6i37Gdl7/view"
                              target="_blank">3.4.1</a></li>
                          <li><a href="https://drive.google.com/file/d/1Cv0YJsWnUe97HCE0_0iR3vWt7zvOPgu2/view"
                              target="_blank">3.4.2</a></li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- criteria 4 -->
            <div class="tab-pane fade" id="v-pills-Criteria4" role="tabpanel" aria-labelledby="v-pills-Criteria4-tab">
              <h3 class="yellow-color">Criteria 4</h3>
              <div class="row row-cols-1 justify-content-start align-items-top mt-3">
                <div class="accordion accordian-class table--1" id="criteria4">
                  <div class="accordion-item">
                    <h2 class="accordion-header accordion-button" id="criteria4-1" data-bs-toggle="collapse"
                      data-bs-target="#criteria4-1-1" aria-expanded="true" aria-controls="collapseOne">
                      4.1
                    </h2>
                    <div id="criteria4-1-1" class="accordion-collapse collapse show" aria-labelledby="criteria4-1"
                      data-bs-parent="#criteria4">
                      <div class="accordion-body">
                        <ul class="list-before">
                          <li><a href="https://drive.google.com/file/d/1HjGLUc7-ld9duh2B-zue_ysXNPO-epUT/view"
                              target="_blank">4.1.1</a></li>
                          <li><a href="https://drive.google.com/file/d/1x04wxMa2nWK91EsowtI-v-CvrxtsSSt-/view"
                              target="_blank">4.1.2</a></li>
                          <li><a href="https://drive.google.com/file/d/15Ql6cEbzlmBCXfqMzplyNE58Czbc3wQQ/view"
                              target="_blank">4.1.3</a></li>
                          <li><a href="https://drive.google.com/file/d/1Qko1x2LZz26p9xtjoZQh-cKqZ94dZHFH/view"
                              target="_blank">4.1.4</a></li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header accordion-button" id="criteria4-3" data-bs-toggle="collapse"
                      data-bs-target="#criteria4-3-1" aria-expanded="true" aria-controls="collapseOne">
                      4.3
                    </h2>
                    <div id="criteria4-3-1" class="accordion-collapse collapse" aria-labelledby="criteria4-3"
                      data-bs-parent="#criteria4">
                      <div class="accordion-body">
                        <ul class="list-before">
                          <li><a href="https://drive.google.com/file/d/1YpbXaLkCNoeRYIJrvUBq6jW2AKSsbycp/view"
                              target="_blank">4.3.1</a></li>
                          <li><a href="https://drive.google.com/file/d/10ZE_BnB--epBSaQx601MJTAd4cCg9Kkl/view"
                              target="_blank">4.3.2</a></li>
                          <li><a href="https://drive.google.com/file/d/12-WV24V-ij1wg2CY047gNV_VlSzEAFNB/view"
                              target="_blank">4.3.3</a></li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="accordion accordian-class table--1" id="criteria_4">
                  <div class="accordion-item">
                    <h2 class="accordion-header accordion-button" id="criteria4-4" data-bs-toggle="collapse"
                      data-bs-target="#criteria4-4-1" aria-expanded="true" aria-controls="collapseOne">
                      4.2
                    </h2>
                    <div id="criteria4-4-1" class="accordion-collapse collapse" aria-labelledby="criteria4-1"
                      data-bs-parent="#criteria_4">
                      <div class="accordion-body">
                        <ul class="list-before">
                          <li><a href="https://drive.google.com/file/d/14rHJWwVYTFF5e2_MDx5RFxVvrFSq3gEm/view"
                              target="_blank">4.2.1</a></li>
                          <!-- <li><a href="https://drive.google.com/file/d/1iTiKbCdq8xOTdQHNoX2ZA_H6YdR7x89z/view" target="_blank">4.2.3</a></li> -->
                          <li><a href="https://drive.google.com/file/d/1iaBN1ADvf_3iQk3oZJrvBoh90AvRWwQx/view"
                              target="_blank">4.2.3</a></li>
                          <li><a href="https://drive.google.com/file/d/1-oWXPrzWo2aOX8UWdcBLfass6Mc-GVeC/view"
                              target="_blank">4.2.4</a></li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header accordion-button" id="criteria4-2" data-bs-toggle="collapse"
                      data-bs-target="#criteria4-2-1" aria-expanded="true" aria-controls="collapseOne">
                      4.4
                    </h2>
                    <div id="criteria4-2-1" class="accordion-collapse collapse" aria-labelledby="criteria4-2"
                      data-bs-parent="#criteria_4">
                      <div class="accordion-body">
                        <ul class="list-before">
                          <!-- <li><a href="#" target="_blank">4.4.1</a></li> -->
                          <li><a href="https://drive.google.com/file/d/1c6GHMj13bLXfhic8cv4OP3s04wieCecb/view"
                              target="_blank">4.4.2</a></li>
                          <!-- <li><a href="#" target="_blank">4.4.3</a></li>
                                        <li><a href="#" target="_blank">4.4.4</a></li>                                           -->
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- criteria 5 -->
            <div class="tab-pane fade" id="v-pills-Criteria5" role="tabpanel" aria-labelledby="v-pills-Criteria5-tab">
              <h3 class="yellow-color">Criteria 5</h3>
              <div class="row row-cols-1 justify-content-start align-items-top mt-3">
                <div class="accordion accordian-class table--1" id="criteria5">
                  <div class="accordion-item">
                    <h2 class="accordion-header accordion-button" id="criteria5-1" data-bs-toggle="collapse"
                      data-bs-target="#criteria5-1-1" aria-expanded="true" aria-controls="collapseOne">
                      5.1
                    </h2>
                    <div id="criteria5-1-1" class="accordion-collapse collapse show" aria-labelledby="criteria5-1"
                      data-bs-parent="#criteria5">
                      <div class="accordion-body">
                        <ul class="list-before">
                          <li><a href="#">5.1.1</a>
                            <ul class="list-before">
                              <li><a
                                  href="https://drive.google.com/file/d/13Y7JkA6Gw7w1W0aD7zJ1Siewc0C4xGfL/view?usp=sharing"
                                  target="_blank">5.1.1.1</a></li>
                            </ul>
                          </li>
                          <li><a href="https://drive.google.com/file/d/1XIkZwu7uI7TYAQNj_fZwHXs103-tzk3P/view"
                              target="_blank">5.1.2</a>
                            <ul class="list-before">
                              <li><a href="https://drive.google.com/file/d/1e9D9Os3UaF_A8lmX65ytCEReS2JviCYD/view"
                                  target="_blank">5.1.2.1</a></li>
                            </ul>
                          </li>
                          <li><a href="https://drive.google.com/file/d/16qGLMJNBhg2ge2EZ3gDyxt-4x_y7_30I/view"
                              target="_blank">5.1.3</a></li>
                          <li><a href="https://drive.google.com/file/d/15hGuf2NyG1YWHzyhd0EPigRtZLTPFP9j/view"
                              target="_blank">5.1.4</a></li>
                          <li><a href="https://drive.google.com/file/d/1kUBJa__ME_I_781UQtC4QxBt_dQFv91L/view"
                              target="_blank">5.1.5</a></li>
                          <!-- <li><a href="https://drive.google.com/file/d/1EdcdydtNIFA5JRHDKZylyaKnZxcw36pz/view" target="_blank">5.1.2</a></li> -->
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header accordion-button" id="criteria5-3" data-bs-toggle="collapse"
                      data-bs-target="#criteria5-3-1" aria-expanded="true" aria-controls="collapseOne">
                      5.3
                    </h2>
                    <div id="criteria5-3-1" class="accordion-collapse collapse" aria-labelledby="criteria5-3"
                      data-bs-parent="#criteria5">
                      <div class="accordion-body">
                        <ul class="list-before">
                          <li><a href="https://drive.google.com/file/d/1VgdhIWGurfi9OSHDyq0gDp4JNV2EvDhR/view"
                              target="_blank">5.3.2</a></li>
                          <li><a href="https://drive.google.com/file/d/1sDz_2TZghIN6oPrfLz--wYOCJuxy49lZ/view"
                              target="_blank">5.3.3</a></li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="accordion accordian-class table--1" id="criteria_5">
                  <div class="accordion-item">
                    <h2 class="accordion-header accordion-button" id="criteria5-2" data-bs-toggle="collapse"
                      data-bs-target="#criteria5-2-2" aria-expanded="true" aria-controls="collapseOne">
                      5.2
                    </h2>
                    <div id="criteria5-2-2" class="accordion-collapse collapse" aria-labelledby="criteria5-2"
                      data-bs-parent="#criteria_5">
                      <div class="accordion-body">
                        <ul class="list-before">
                          <li><a href="https://drive.google.com/file/d/1Tj4Wn3HeoFo9rJfQYkmJSW0EzFGkJmDM/view"
                              target="_blank">5.2.1</a></li>
                          <li><a href="https://drive.google.com/file/d/1caVk6tv-OULFr2Mdowb-0MGs0xtgATO6/view"
                              target="_blank">5.2.2</a></li>
                          <li><a href="https://drive.google.com/file/d/1GVHEyBNsm6oe5QYcYenMBjtmheJGOZVZ/view"
                              target="_blank">5.2.3</a></li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header accordion-button" id="criteria5-4" data-bs-toggle="collapse"
                      data-bs-target="#criteria5-4-1" aria-expanded="true" aria-controls="collapseOne">
                      5.4
                    </h2>
                    <div id="criteria5-4-1" class="accordion-collapse collapse" aria-labelledby="criteria5-4"
                      data-bs-parent="#criteria_5">
                      <div class="accordion-body">
                        <ul class="list-before">
                          <li><a href="https://drive.google.com/file/d/1YT2SnJNzuorRHs7hOOwYWqTddJ_rinvl/view"
                              target="_blank">5.4.1</a></li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- criteria 6 -->
            <div class="tab-pane fade" id="v-pills-Criteria6" role="tabpanel" aria-labelledby="v-pills-Criteria6-tab">
              <h3 class="yellow-color">Criteria 6</h3>
              <div class="row row-cols-1 justify-content-start align-items-top mt-3">
                <div class="accordion accordian-class table--1" id="criteria6">
                  <div class="accordion-item">
                    <h2 class="accordion-header accordion-button" id="criteria6-1" data-bs-toggle="collapse"
                      data-bs-target="#criteria6-1-1" aria-expanded="true" aria-controls="collapseOne">
                      6.1
                    </h2>
                    <div id="criteria6-1-1" class="accordion-collapse collapse show" aria-labelledby="criteria6-1"
                      data-bs-parent="#criteria6">
                      <div class="accordion-body">
                        <ul class="list-before">
                          <li><a href="https://drive.google.com/file/d/1JDn4pQ3ZqraRpo4_-eJ3f1DPMoj6oPOb/view"
                              target="_blank">6.1.1</a></li>
                          <li><a href="https://drive.google.com/file/d/1eRlovAA4NnhjvK6TJ7FXIKq-ZIcegL1o/view"
                              target="_blank">6.1.2</a></li>
                        </ul>
                      </div>
                    </div>
                  </div>

                  <div class="accordion-item">
                    <h2 class="accordion-header accordion-button" id="criteria6-3" data-bs-toggle="collapse"
                      data-bs-target="#criteria6-3-1" aria-expanded="true" aria-controls="collapseOne">
                      6.3
                    </h2>
                    <div id="criteria6-3-1" class="accordion-collapse collapse" aria-labelledby="criteria6-3"
                      data-bs-parent="#criteria6">
                      <div class="accordion-body">
                        <ul class="list-before">
                          <li><a href="https://drive.google.com/file/d/1kJrwBL76mYd4-15MFOHPWubOPqolU6XB/view"
                              target="_blank">6.3.1</a></li>
                          <li><a href="https://drive.google.com/file/d/1GCIogj7oGdu5mtoKw07H9hNstI96LDWd/view"
                              target="_blank">6.3.2</a></li>
                          <li><a href="https://drive.google.com/file/d/1JtSc-eZi3Kp0lSoHUWwY0587CtD_dpV4/view"
                              target="_blank">6.3.3</a></li>
                          <li><a href="assets/pdf/6.3.4.pdf" target="_blank">6.3.4</a></li>
                          <li><a href="https://drive.google.com/file/d/1FxCbQ3-XQVYEFlk-TkgXXHDfcayj0V-_/view"
                              target="_blank">6.3.5</a></li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header accordion-button" id="criteria6-5" data-bs-toggle="collapse"
                      data-bs-target="#criteria6-5-1" aria-expanded="true" aria-controls="collapseOne">
                      6.5
                    </h2>
                    <div id="criteria6-5-1" class="accordion-collapse collapse" aria-labelledby="criteria6-5"
                      data-bs-parent="#criteria6">
                      <div class="accordion-body">
                        <ul class="list-before">
                          <li><a href="https://drive.google.com/file/d/1et40XCfI7sdLx0u20c3o_Hf9e3ENEtYs/view"
                              target="_blank">6.5.1</a></li>
                          <li><a href="https://drive.google.com/file/d/1dNLlBB7GXZg8uOui6baaKS21cmgdQh4D/view"
                              target="_blank">6.5.2</a></li>
                          <li><a href="https://drive.google.com/file/d/1jqgWtx-ulmSowGukYvpa2MfcqQNd4fWF/view"
                              target="_blank">6.5.3</a></li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="accordion accordian-class table--1" id="criteria_6">
                  <div class="accordion-item">
                    <h2 class="accordion-header accordion-button" id="criteria6-2" data-bs-toggle="collapse"
                      data-bs-target="#criteria6-2-3" aria-expanded="true" aria-controls="collapseOne">
                      6.2
                    </h2>
                    <div id="criteria6-2-3" class="accordion-collapse collapse" aria-labelledby="criteria6-2"
                      data-bs-parent="#criteria_6">
                      <div class="accordion-body">
                        <ul class="list-before">
                          <li><a href="https://drive.google.com/file/d/1lBApLEvfLyma4jWBWoOCZ5JE-q4IZ9Ek/view"
                              target="_blank">6.2.1</a></li>
                          <li><a href="https://drive.google.com/file/d/1qYfzKAc8gthtSngW8UzCfcoq5yIH_x5F/view"
                              target="_blank">6.2.2</a></li>
                          <li><a href="https://drive.google.com/file/d/11-2fTGSITU5IK_B2ykA_MQDvFJeGp9HE/view"
                              target="_blank">6.2.3</a></li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header accordion-button" id="criteria6-4" data-bs-toggle="collapse"
                      data-bs-target="#criteria6-4-1" aria-expanded="true" aria-controls="collapseOne">
                      6.4
                    </h2>
                    <div id="criteria6-4-1" class="accordion-collapse collapse" aria-labelledby="criteria6-4"
                      data-bs-parent="#criteria_6">
                      <div class="accordion-body">
                        <ul class="list-before">
                          <li><a href="https://drive.google.com/file/d/1WDRkoPqp_o3qtWrHWICC7PaU9UNdk96L/view"
                              target="_blank">6.4.1</a></li>
                          <li><a href="https://drive.google.com/file/d/1NzDop_cEgMd53d6wl8HSoinJRVd4nMAO/view"
                              target="_blank">6.4.3</a></li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- criteria 7 -->
            <div class="tab-pane fade" id="v-pills-Criteria7" role="tabpanel" aria-labelledby="v-pills-Criteria7-tab">
              <h3 class="yellow-color">Criteria 7</h3>
              <div class="row row-cols-1 justify-content-start align-items-top mt-3">
                <div class="accordion accordian-class table--1" id="criteria7">
                  <div class="accordion-item">
                    <h2 class="accordion-header accordion-button" id="criteria7-1" data-bs-toggle="collapse"
                      data-bs-target="#criteria7-1-2" aria-expanded="true" aria-controls="collapseOne">
                      7.1
                    </h2>
                    <div id="criteria7-1-2" class="accordion-collapse collapse" aria-labelledby="criteria7-1"
                      data-bs-parent="#criteria7">
                      <div class="accordion-body">
                        <ul class="list-before">
                          <li><a href="https://drive.google.com/file/d/1a1OQ-Gm9kFbY6rthqNwquoe6T-yQkCwL/view"
                              target="_blank">7.1.1</a></li>
                          <li><a href="https://drive.google.com/file/d/1ARRA7w-EAnMUL8-hjFGri2347gi1azkq/view"
                              target="_blank">7.1.2</a></li>
                          <li><a href="https://drive.google.com/file/d/10qXLZ-wJwCl1dqnlpzTpxGuKFrMbRNrs/view"
                              target="_blank">7.1.3</a></li>
                          <li><a href="https://drive.google.com/file/d/1Ft-FZjIH7kaTLANLDkyFkTiR_uPejvru/view"
                              target="_blank">7.1.5</a></li>
                          <li><a href="https://drive.google.com/file/d/1PfUTYDBuufK8bIiWDzNJAFybip02nX8z/view"
                              target="_blank">7.1.6</a></li>
                          <li><a href="https://drive.google.com/file/d/1FQX5XRrvYwVr8gxSpkhIY5KV4menWvP1/view"
                              target="_blank">7.1.7</a></li>
                          <li><a href="https://drive.google.com/file/d/1fxqtDguLT2ooN2KqIvjWuLrJno8UPEl2/view"
                              target="_blank">7.1.8</a></li>
                          <li><a href="https://drive.google.com/file/d/1r3U_uGoOM3WgV45VJjB3oSffiS-7aEuU/view"
                              target="_blank">7.1.9</a></li>
                          <li><a href="https://drive.google.com/file/d/1E5NUFFV7KVaijc644n5Bz-5nL6mOhPzg/view"
                              target="_blank">7.1.10</a></li>
                          <li><a href="https://drive.google.com/file/d/11IcZwTU_mMFCti_nxd6bUt9n0xomUy9P/view"
                              target="_blank">7.1.11</a></li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header accordion-button" id="criteria7-3" data-bs-toggle="collapse"
                      data-bs-target="#criteria7-3-1" aria-expanded="true" aria-controls="collapseOne">
                      7.3
                    </h2>
                    <div id="criteria7-3-1" class="accordion-collapse collapse" aria-labelledby="criteria7-3"
                      data-bs-parent="#criteria7">
                      <div class="accordion-body">
                        <ul class="list-before">
                          <li>
                            <a href="https://drive.google.com/file/d/1mudLPJmrhRpOTdHiRFN3h2EoV6ywPHYS/view"
                              target="_blank">7.3.1</a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="accordion accordian-class table--1" id="criteria_7">
                  <div class="accordion-item">
                    <h2 class="accordion-header accordion-button" id="criteria7-2" data-bs-toggle="collapse"
                      data-bs-target="#criteria7-2-1" aria-expanded="true" aria-controls="collapseOne">
                      7.2
                    </h2>
                    <div id="criteria7-2-1" class="accordion-collapse collapse" aria-labelledby="criteria7-2"
                      data-bs-parent="#criteria_7">
                      <div class="accordion-body">
                        <ul class="list-before">
                          <li>
                            <a href="https://drive.google.com/file/d/1vi5d1NiDtGwxkVhOxBZtC2ll44N00NAc/view"
                              target="_blank">7.2.1</a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header accordion-button" id="criteria7-17" data-bs-toggle="collapse"
                      data-bs-target="#criteria7-17-1" aria-expanded="true" aria-controls="collapseOne">
                      7.17
                    </h2>
                    <div id="criteria7-17-1" class="accordion-collapse collapse" aria-labelledby="criteria7-11"
                      data-bs-parent="#criteria_7">
                      <div class="accordion-body">
                        <ul class="list-before">
                          <li><a href="https://drive.google.com/file/d/1MqDCCt8w4x8zW9_nQdYNIU_hV0RJ6QLf/view"
                              target="_blank">7.17</a></li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- extended template -->
            <div class="tab-pane fade" id="v-pills-template" role="tabpanel" aria-labelledby="v-pills-template-tab">
              <h3 class="yellow-color">Extended Template</h3>
              <div class="row row-cols-1 justify-content-start align-items-top mt-3">
                <div class="accordion accordian-class table--1" id="template">
                  <div class="accordion-item">
                    <h2 class="accordion-header accordion-button" id="extended" data-bs-toggle="collapse"
                      data-bs-target="#extended_template" aria-expanded="true" aria-controls="collapseOne">
                      Extended Template
                    </h2>
                    <div id="extended_template" class="accordion-collapse collapse" aria-labelledby="extended"
                      data-bs-parent="#template">
                      <div class="accordion-body">
                        <ul class="list-before">
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
